module.exports = __webpack_public_path__ + "static/media/no-app.7cc8ab0a.svg";